module.exports = __webpack_public_path__ + "firefox_logo-only.35f70b64.svg";